import React from 'react';
import { Tooltip, tooltipClasses, styled } from '@mui/material';

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    placement={props.placement}
  />
))(({ theme, ...props }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
    bottom: '1px !important',
    left: props.placement === 'top' ? '0px !important' : '-8px !important'
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    maxWidth: 180,
    textAlign: 'center',
    borderRadius: '20px',
    padding: '10px 10px 10px 15px !important',
    fontSize: theme.typography.pxToRem(13)
  }
}));
export default CustomTooltip;
